import { render, staticRenderFns } from "./NucleiMemberDialog.vue?vue&type=template&id=204b0805&scoped=true"
import script from "./NucleiMemberDialog.vue?vue&type=script&lang=js"
export * from "./NucleiMemberDialog.vue?vue&type=script&lang=js"
import style0 from "./NucleiMemberDialog.vue?vue&type=style&index=0&id=204b0805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b0805",
  null
  
)

export default component.exports